var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"align-stretch"},[_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('solution-card',{staticStyle:{"height":"100%"},attrs:{"solution-id":_vm.favSolutions[0] || 0}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('solution-card',{staticStyle:{"height":"100%"},attrs:{"solution-id":_vm.favSolutions[1] || 0}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }